<template>
    <LayoutDefault :title-page="'Tabela Unica de Exames Veus'">
        <h2 v-b-toggle.mainCollapse class="mt-2 mb-2">Cadastros</h2>
        <b-collapse id="mainCollapse" class="mt-2a" visible>
            <b-card>
                <b-table striped hover :items="items" :fields="table_fields">
                    <template v-slot:cell(action)>
                        <b-button v-b-modal.relatedExams>Ver exames relacionados</b-button>
                        <b-button>Ver exames relacionados</b-button>
                    </template>
                </b-table>
            </b-card>
        </b-collapse>

        <h2 v-b-toggle.secondaryCollapse class="mt-2 mb-2">Estatisticas</h2>
        <b-collapse id="secondaryCollapse" class="mt-2" visible>
            <b-card-group deck>
                <b-card class="w-25 p-3 mb-1">
                    <strong>Volume de sinonimos por origem</strong>
                    <br/>
                    <pie-chart :data="first_chart_origin" legend="bottom"></pie-chart>
                </b-card>
                <b-card class="w-25 p-3 mb-1">
                    <strong>Volume de sinonimos por lingua</strong>
                    <br/>
                    <pie-chart :data="first_chart_lang" legend="bottom"></pie-chart>
                </b-card>
            </b-card-group>
        </b-collapse>
    </LayoutDefault>
</template>

<script>
    import LayoutDefault from "@/templates/LayoutDefault";

    export default {
        name: "Dashboard",
        components: {LayoutDefault},
        data() {
            return {
                first_chart_origin: [['LIS', 44], ['Hermes Pardini', 23], ['DB', 80]],
                first_chart_lang: [['en_US', 34], ['es_SP', 43], ['pt_BR', 16]],
                table_fields: [
                    {key: 'synonym', label: 'Sinonimo', sortable: true},
                    {key: 'origin', label: 'Origem', sortable: true},
                    {key: 'lang', label: 'Lingua', sortable: true},
                    {key: 'action', label: 'Acoes'},

                ],
                items: [
                    {synonym: "Glico", origin: 'LIS', lang: 'pt_BR'},
                    {synonym: "HEMO", origin: 'LIS', lang: 'pt_BR'},
                    {synonym: "Defuxotetradona", origin: 'LIS', lang: 'pt_BR'},
                ]
            }
        }
    }
</script>
